/**
 * 多租户配置 —— 全项目唯一配置点
 *
 * 分支映射：online / online-zx → xf；online-zzl → zzl
 * 切换租户分支时，只需修改本文件的 TENANT_ID 一行，其余代码无需改动。
 */
export const TENANT_ID = 'xf'

/**
 * 租户请求头
 * 用于无法走 axios 拦截器 / 全局默认头的场景（如 el-upload 直传、原生 XHR）
 */
export const TENANT_HEADERS = { 'X-Tenant-Id': TENANT_ID }
